import { z } from 'zod';

// +---------+
// | Request |
// +---------+

const ClickHouseApiStringDateSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);

export const ClickHouseApiQueryVariablesSchema = z.object({
  to_date: ClickHouseApiStringDateSchema,
  from_date: ClickHouseApiStringDateSchema,
  // database: z.string(),
  pageview_date: z.string().optional(),
  environment_guid: z.string().uuid(),
});

export type ClickHouseApiQueryVariables = z.infer<typeof ClickHouseApiQueryVariablesSchema>;

// +----------+
// | Response |
// +----------+

function ClickHouseApiHeaderResponseSchemaBuilder<U extends string, T extends Readonly<[U, ...U[]]>>(
  headers: T,
  strict = true
) {
  const mainSchema = z.array(
    z.object({
      name: z.enum<string, typeof headers>(headers),
      type: z.string(),
    })
  );

  if (strict) return mainSchema.length(headers.length);

  return mainSchema;
}

export function ClickHouseApiResponseSchemaBuilder<U extends string, T extends Readonly<[U, ...U[]]>>(
  headers: T,
  strict = true
) {
  const headersSchema = ClickHouseApiHeaderResponseSchemaBuilder(headers, strict);

  const objectSchema = strict ? z.array(z.array(z.any())).length(headers.length) : z.array(z.array(z.any()));

  return z.object({
    meta: headersSchema,
    data: objectSchema,
  });
}

export const ClickHouseApiGenericResponseSchema = z.object({
  meta: z.array(
    z.object({
      name: z.string(),
      type: z.string(),
    })
  ),
  data: z.array(z.array(z.any())),
});

export type ClickHouseApiGenericResponse = z.infer<typeof ClickHouseApiGenericResponseSchema>;
